<script setup lang="ts">
// to do - pagination

const sanity = useSanity()

// all articles data
const articlesQuery = groq`*[_type == "articles"]{
  title,
    heading,
    subtitle,
    body,
    slug,
    image{
      ...,
      "asset": {
        "_ref": asset._ref,
        "metadata": {
          "lqip": asset->metadata.lqip,
        }
      }
    },
    date,
    _id,
} | order(date desc) [0...4]`

const { data: articles, error } = await useAsyncData(articlesQuery, async () => sanity.fetch<Sanity.Default.Schema.Articles[]>(articlesQuery))

if (error.value) {
  console.error(error)
  throw createError({ status: 404, message: 'No Articles found' })
}
</script>

<template>
  <div
    v-if="articles"
    class="w-full"
  >
    <UiBtn
      variant="link"
      color="forest"
      size="lg"
      to="/articles"
      label="News & Comment"
      class="mb-4"
      :padded="false"
    />
    <div class="mx-auto flex max-w-2xl flex-col items-start justify-start gap-16 lg:mx-0 lg:max-w-none lg:flex-row">
      <div
        v-if="articles.length > 0"
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5"
      >
        <ArticlesCard
          v-for="article in articles"
          :key="article?._id"
          :article="article"
        />
      </div>
      <div v-else>
        <p class="text-base font-bold leading-7 text-gray-700">
          There are currently no articles.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
